module.exports = __webpack_public_path__ + "img/graduate-1987-xiangshan.f3951162.jpg";